<template>
    <TheDetailsGallery :gallery="gallery" />
    <div class="container">
        <div class="row px-4">
            <div class="col-12 col-lg-6">
                <div class="row">
                    <h5 class="fw-bold pb-3" :style="branding.titles">Why Get This Luxury Vacation Package?</h5>
                    <div class="col-1 text-end">
                        <img src="../../assets/icons/check_circle.svg" alt="">
                    </div>
                    <div class="col">
                        <p> <span class="fw-bold">5 Days and 4 Nights</span> at our Luxury Oceanfront Resort in {{
                            getDestination.name }},
                            Mexico.</p>
                    </div>
                    <hr class="shuted-line">
                    <div class="col-1 text-end">
                        <img src="../../assets/icons/check_circle.svg" alt="">
                    </div>
                    <div class="col">
                        <p><span class="fw-bold">All water sports</span> and nonmotorized activities are also <span
                                class="fw-bold">included</span> in your reservation.</p>
                    </div>
                    <hr class="shuted-line">
                    <div class="col-1 text-end">
                        <img src="../../assets/icons/check_circle.svg" alt="">
                    </div>
                    <div class="col">

                        <p><span class="fw-bold">All-Inclusive:</span> With unlimited à la carte and buffet-style
                            dining, a wide variety of cocktails
                            and international beverages, nightly entertainment, and daily entertainment.</p>
                    </div>
                    <hr class="shuted-line">
                    <div class="col-12 pb-lg-5 pt-3">
                        <div
                            class="col-12 col-lg-7 border border-black rounded justify-content-center align-items-center p-3  d-none d-lg-flex">
                            <img src="../../assets/icons/paid.svg" alt="">
                            <h5 class="fw-bold p-0 m-0" :style="branding.detailsTitleBoxTip">Save Over 70%!*</h5>

                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <div class="row">
                    <h5 class="fw-bold pb-3" :style="branding.titles">Why You Get It</h5>
                    <div class="col-1 text-end">
                        <img src="../../assets/icons/check_circle.svg" alt="">
                    </div>
                    <div class="col">
                        <div v-html="rightColumnIntro"></div>
                    </div>
                    <hr class="shuted-line">
                    <div class="col-1 text-end">
                        <img src="../../assets/icons/check_circle.svg" alt="">
                    </div>
                    <div class="col">
                        <p>This is an exclusive offer for those who value their time and know they deserve the best.
                            Don’t miss this chance to enjoy a dream vacation at an incredible price.</p>
                    </div>
                    <hr class="shuted-line">
                    <div class="col-12 pb-4 pt-2">
                        <div
                            class="col-12 col-lg-5 border border-black rounded d-flex justify-content-center align-items-center p-3 d-lg-none">
                            <img src="../../assets/icons/paid.svg" alt="">
                            <h5 class="fw-bold  p-0 m-0" :style="branding .detailsTitleBoxTip">Save Over 70%!*</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TheDetailsGallery from "@/components/landing-page/TheDetailsGallery.vue"
import { useStore } from '@/store/landing';

export default {
    props: {
        gallery: {
            type: Array,
            required: true
        },
        details: {
            type: Object,
            required: false
        }
    },
    components:
    {
        TheDetailsGallery
    },
    computed: {
        websiteStore() {
            return useStore();
        },
        getDestination() {
            return this.websiteStore.destinations.find(destination => destination.slug === this.$route.params.destinationSlug)
        },
        getBackground() {
            return 'backgroundImage' + ':' + `url(${this.getDestination.backgrounds[0]})`
        },
        branding() {
            return this.websiteStore.getCampaignBranding(this.$route.query.utm_campaign);
        },
        getCopy() {
            return this.websiteStore.getCampaignCopy(this.$route.query.utm_campaign, this.$route.params.destinationSlug);
        },
        rightColumnIntro() {
            return this.getCopy.details.rightColumn.bullets[0]
            .replace('{{retailPrice}}', this.getCopy.retailPriceUSD)
            .replace('{{priceUSD}}', this.getCopy.priceUSD);
        }
    }
}
</script>

<style scoped>
.border-black {
    border: 1px solid #262626 !important;
}

h5 {
    color: #FF1F1F;
}

hr.shuted-line {
    border-top: 1px dashed;
}
</style>
